// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.not-found[data-v-59e1319f] {\n  font-family: 'Josefin Sans', sans-serif;\n}\n.not-found-h1[data-v-59e1319f] {\n  font-size: 50px;\n  margin-bottom: 0;\n  line-height: 1;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
